import { useState } from "react";
import { activateUser } from "../../app/requests/annonymous";


export function VerifyUserScreen() {
    const [password, setPassword] = useState('');
    const [UserName, setUserName] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [loading, setIsLoading] = useState(false);

    const handlePasswordChange = (event) => {
        setPassword(event.target.value);
    }

    const handleUserNameChange = (event) => {
        setUserName(event.target.value);
    }

    const handleUserVeryfi = () => {
        setIsLoading(true);
        setError('');
        setSuccess(false);
        
        let token = window.location.pathname.split('/')[2];
        activateUser(token, UserName, password)
            .then(() => {
                setSuccess(true);
                // window.open('/');
            })
           .catch((error) => { console.log(error.response); setError(error.response.status === 400 ? error.response.data : 'Wystąpił błąd') });
        setIsLoading(false);
    }

    return (
        <div className="p-2">
            <div className="p-8 my-8 mx-auto border-2 bg-base-200 border-gray-300 rounded-md max-w-lg">
                <h1 className="text-2xl font-bold">Weryfikacja konta SBK24</h1>
                <br />
                <label className="text-sm font-bold ml-1">Nazwa użytkownika</label>
                <br />
                <input
                    type="text"
                    placeholder="Login"
                    className="input input-bordered w-full max-w-xs mb-2 rounded-sm"
                    value={UserName}
                    onChange={e => setUserName(e.target.value)}

                />
                <br />

                <label className="text-sm font-bold mt-2 ml-1">Hasło</label>
                <br />
                <input
                    type="password"
                    placeholder="Hasło"
                    className="input input-bordered w-full max-w-xs mb-2 rounded-sm"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    onKeyDown={event => { if (event.key === 'Enter') setPassword.catch(); }}
                />
                <br />

                <button
                    className={"btn bg-yellow-600 border-none rounded-sm" + (loading ? " loading" : "")}
                    type="button"
                    disabled={loading}
                    onClick={handleUserVeryfi}
                >
                    {loading ? 'Ładowanie...' : 'Weryfikuj'}
                </button>


                {error !== "" ?
                    <div className="alert alert-error shadow-lg mt-4">
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current flex-shrink-0 h-6 w-6"
                                fill="none"
                                viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                    d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <span>{error}</span>
                        </div>
                    </div> : <div />
                }
                {success ?
                    <div className="alert alert-success shadow-lg mt-4">
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current flex-shrink-0 h-6 w-6"
                                fill="none"
                                viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                    d="M5 13l4 4L19 7" />
                            </svg>
                            <span>Konto zostało aktywowane</span>
                        </div>
                    </div> : <div />
                }
            </div>
        </div>
    );
}